import { gql } from "config/graphql";

export const UNDERWRITING_AVAILABILITY_FIELDS = gql`
  fragment UnderwritingAvailabilityFields on User {
    coverageAdjustmentAvailable: underwritingRequestAvailable(applicationType: coverage_adjustment)
    reinstatementAvailable: underwritingRequestAvailable(applicationType: reinstatement)
  }
`;
